import { Selector, createFeatureSelector, createSelector } from '@ngrx/store';

import { AccountCertificate } from '@personal-area/global/accounts/models';
import {
  AccountState,
  getAccountsArray,
} from '../reducers/account';

const getAccountsStore = createFeatureSelector<AccountState>('accounts');

export const getAllAccounts = createSelector(
  getAccountsStore,
  ({ accounts }) => ({
    accounts: getAccountsArray(accounts),
    loadingState: accounts.loadingState,
  }),
);

export const getSelectedAccountID = createSelector(
  getAccountsStore,
  ({ selected }) => selected,
);

export const getSelectedAction = createSelector(
  getAccountsStore,
  ({ action }) => action,
);

export const getAccountsLoadingState = createSelector(
  getAccountsStore,
  ({ accounts }) => accounts.loadingState,
);

export const getCertificate = (
  accountID: number,
): Selector<AccountState, AccountCertificate | undefined> =>
  createSelector(getAccountsStore, (state) => state.certificates[accountID]);
